import { useEffect, useState } from "react";
import { useApi } from "../../../../../utils/hooks";
import { useAuth } from "../../../../../auth/context";
import useIsAsyncPatientSearch from "./useIsAsyncPatientSearch";

const loadErrorMessage = "No se pudieron cargar los pacientes. Recargá la página o contactanos a consultas@recetario.com.ar";

const usePatientSearchStrategy = () => {
  const [patients, setPatients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoadFailed, setHasLoadFailed] = useState(false);
  const api = useApi();
  const { user } = useAuth();
  const shouldSearchAsync = useIsAsyncPatientSearch();
  const filterPatients = (patientsData) => user.filterPatients(patientsData);

  useEffect(() => {
    if (shouldSearchAsync) return;

    api.patients()
      .then(
        (patientsData) => setPatients(filterPatients(patientsData)),
        () => setHasLoadFailed(true)
      )
      .finally(() => setIsLoading(false));
  }, []);

  const onAsyncSearch = (search) => {
    return api.patients({ search }).then(filterPatients);
  };

  const strategyProps = shouldSearchAsync
    ? { onAsyncSearch }
    : { patients, loading: isLoading };

  const loadErrorAlertProps = {
    show: hasLoadFailed,
    alwaysVisible: true,
    onClose: () => setHasLoadFailed(false),
    message: loadErrorMessage,
  };

  return {
    strategyProps,
    loadErrorAlertProps
  };
};

export default usePatientSearchStrategy;
